export const AppConstants = {
  Buttons: {
    ViewProjects: "View Projects",
    ViewResume: "View Resume",
    ContactMe: "Contact Me",
  },
  NavigationMenus: {
    Home: "Home",
    About: "About",
    Skills: "Skills",
    Portfolio: "Portfolio",
    Contact: "Contact",
    Experience: "Experience",
  },
  Images: {
    Avatar: "./Images/Color_Avatar.png",
    Resume: "./Images/Resume.png",
    Logo: "./Images/Spiral1.png",
    AboutGif: "./Images/Gif_Img",
    LocationIcon: "/Images/Location1.png",
    HTMLTag: "./Images/HTML_TAG.png",
  },
  ImagePaths: {
    Languages: {
      Java: "./Images/Languages/Java.png",
      HTML: "./Images/Languages/Html.png",
      CSS: "./Images/Languages/Css.png",
      SCSS: "./Images/Languages/Scss.png",
      Tailwind: "./Images/Languages/Tailwind.png",
      JavaScript: "./Images/Languages/JavaScript.png",
      TypeScript: "./Images/Languages/Typescript.png",
      React: "./Images/Languages/React.png",
      Bootstrap: "./Images/Languages/Boostrap.png",
      Material: "./Images/Languages/Material.png",
      Node: "./Images/Languages/Node.png",
      Express: "./Images/Languages/Express.png",
      NestJS: "./Images/Languages/Nest.png",
      MongoDB: "./Images/Languages/Mongo.png",
      MySQL: "./Images/Languages/Sql.png",
      PostgreSQL: "./Images/Languages/Postgresql.png",
      Firebase: "./Images/Languages/Firebase.png",
      Git: "./Images/Languages/Git.png",
      Github: "./Images/Languages/Github.png",
      Docker: "./Images/Languages/Docker.png",
      AWS: "./Images/Languages/Aws.png",
      Python: "./Images/Languages/Python.png",
      Django: "./Images/Languages/Django.png",
      Figma: "./Images/Languages/FIgma.png",
      Postman: "./Images/Languages/Postman.png",
      Vercel: "./Images/Languages/Vercel.png",
      VSCode: "./Images/Languages/Vscode.png",
    },
    Projects: {
      YTBookmarks: "./Images/YT_Learning/My_YT_Bookmarks.png",
      MedcareMedlife: "./Images/Medcare_Medlife/Home.png",
      MovieApp: "./Images/The_Movie_App/The_Movie.png",
      OrganizeMe: "./Images/Advance_toodoo/Home.png",
      Memas: "./Images/Memas/Signup.png",
      CameraGallery: "./Images/Camera_Gallery/Camera_Gallery.png",
      WeatherCraft: "./Images/Weather_Application/home.png",
    },
  },
  Resume: {
    ResumeLink: "./Mann-Mendapara-Resume-2023-12-18.pdf",
    ResumeName: "Resume-Mankumar_Mendapara.pdf",
  },
  NavLinks: [
    { id: "home", label: "Home" },
    { id: "about", label: "About" },
    { id: "skills", label: "Skills" },
    { id: "portfolio", label: "Projects" },
    { id: "experience", label: "Experience" },
    { id: "contact", label: "Contact" },
  ],
  CommonWords: {
    Me: "Me",
    My: "My",
    IM: "I'm",
    Selected: "Selected",
    Works: "Works",
    TechStack: "Tech Stack",
    Or: "or",
  },
  ContactForm: {
    ThankYouForSubmitting: "Thank you for Submitting.",
    SendAMessage: "Send a Message",
    Placeholders: {
      Name: "Name",
      Email: "email",
      Message: "Message",
    },
    ButtonText: "Send Message",
    Validation: {
      NameRequired: "Please Enter your name.",
      EmailInvalid: "Please Enter valid email address.",
      MessageRequired: "Please Enter your message.",
    },
    FormKeys: {
      Name: "Name",
      Email: "Email",
      Message: "Message",
    }
  },
  Location: {
    Coordinates: [23.021, 72.520],
    MapZoom: 15,
    CompanyName: "Thinkbiz Technology Pvt Ltd.",
    City: "Ahmedabad",
  },
  SocialLinks: {
    LinkedIn: "https://www.linkedin.com/in/mann-mendapara-6a0276268/",
    GitHub: "https://github.com/MannMendapara",
    Email: "mannmendapara13@gmail.com",
  },
};
